import { ColDef } from "ag-grid-community";
import { getPercentage } from "@/utils/numeral/getPercentage";

export const utilizationComparatorFn: ColDef["comparator"] = (
  _,
  __,
  nodeA,
  nodeB,
) => {
  const valueA = nodeA.data;
  const valueB = nodeB.data;

  const valueAUsedCost = valueA?.used_commitment_to_date?.cost;
  const valueATotalCost = valueA?.total_commitment_to_date?.cost;
  const valueAPercent = +getPercentage(
    valueAUsedCost ?? 0,
    valueATotalCost ?? 0,
  ).toFixed(2);

  const valueBUsedCost = valueB?.used_commitment_to_date?.cost;
  const valueBTotalCost = valueB?.total_commitment_to_date?.cost;
  const valueBPercent = +getPercentage(
    valueBUsedCost ?? 0,
    valueBTotalCost ?? 0,
  ).toFixed(2);

  if (isNaN(valueAPercent)) {
    return -1;
  }
  if (isNaN(valueBPercent)) {
    return 1;
  }

  return valueAPercent > valueBPercent ? 1 : -1;
};
